var http = window.location.protocol;
if (http != "http:" && http != "https:") {
    http = "https:";
}
const config = {
    'tenantId': 927,//正式租户ID
    'schemaId': 605,//正式体系ID
    'weChatId': 31815,//正式weChatId
    //'formId': 5099,//注册表单 id
    'formId': 7215,
    'dicId': 382586,
    'appId': 'wx8634dc3bdbe04d38', // 网站应用appid
    'num': 18,
    'webUrl':'https://kee.smarket.net.cn/2019/index.html',
    'cookie': {
        'json': true,
       // 'domain': '.smarket.net.cn',
        'domain': '.smarket.net.cn',
        'path':'/',
        'expires':'7d',
        'flag': {
            'member': 'smarketMember',
            'openId': 'openId',
            'customForm': 'smarketCustomForm'
        }
    },
    s2Url:http+"//api.smarket.net.cn"
};

export default config
